import { render, staticRenderFns } from "./tem-edit.vue?vue&type=template&id=729a76c2&scoped=true"
import script from "./tem-edit.vue?vue&type=script&lang=ts"
export * from "./tem-edit.vue?vue&type=script&lang=ts"
import style0 from "./tem-edit.vue?vue&type=style&index=0&id=729a76c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729a76c2",
  null
  
)

export default component.exports